<template>
  <div class="tr-select-image">
    <tr-image
      v-for="(item, index) in dataElements"
      :key="item.key"
      :pos="item.pos"
      :image-data-model="imageObjects[index]"
      :image-path="item.imagePath"
      :scale-image="item.scaleImage"
      :offset-vertical="item.offsetVertical"
      :offset-horizontal="item.offsetHorizontal"
      @trClick="clickAction"
    ></tr-image>
  </div>
</template>
<script>
import _ from 'lodash';
import TrImage from '../../GameBaseElements/TrBox/TrImage';
export default {
  name: 'tr-select-image',
  components: {
    TrImage,
  },
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data: function () {
    return {
      dataElements: {},
      imageObjects: [],
    };
  },
  created() {},
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.dataElements = this.prepareData();
      this.dataElements = this.addLayout();
      this.imageObjects = _.map(this.dataElements, (item) => {
        /**
         * image value and status
         * @type {String} rest - nothing
         * @type {String} selected - image
         * @type {String} correct - image
         * @type {String} incorrect - image
         */
        return _.extend({
          index: item.index,
          correct: _.isBoolean(item.correct) ? item.correct : false,
          block: false,
          status: 'rest',
        });
      });
      // console.log('this.dataElements', this.dataElements);
      // console.log('this.imageObjects', this.imageObjects);
    },
    prepareData() {
      let data = this.startGameConfig.items;
      if (this.startGameConfig.shuffle) {
        data = _.shuffle(this.startGameConfig.items);
      }
      if (this.startGameConfig.pick) {
        data = _.sampleSize(data, this.startGameConfig.pick);
      }
      data = _.map(data, (item, index) => {
        return _.extend(item, { index, scaleImage: item.scaleImage });
      });
      // console.log( 'data', data );
      return data;
    },
    addLayout() {
      let data = this.dataElements;
      data = _.map(this.startGameConfig.imageLayout, (item, index) => {
        return Object.assign(data[index], item);
      });
      return data;
    },
    // getImageStyle(imageData) {
    //   return {
    //     'position': 'absolute',
    //     'background-image': 'url(\'static/' + imageData.imagePath + '\')',
    //     'top': utils.elementTopPosition(imageData.pos.y, imageData.offsetVertical),
    //     'left': utils.elementLeftPosition(imageData.pos.x, imageData.offsetHorizontal),
    //     'width': utils.elementWidth(imageData.pos.width),
    //     'height': utils.elementHeight(imageData.pos.height),
    //   };
    // },
    clickAction(event, index) {
      this.imageObjects[index] = _.extend(this.imageObjects[index], {
        status: this.imageObjects[index].status === 'selected' ? 'rest' : 'selected',
      });
      return true;
    },
    /**
     * reset all containerEnd without reset reactivity
     * @method resetGameAction
     */
    resetGameAction() {
      // _.each(this.inputData, (item, key, collection) => {
      //   item.val = "";
      //   item.block = false;
      //   item.inputStatus = null;
      // });
      this.init();
      // this.questionsList = this.processQuestionsList();
    },
    checkGameAction() {
      let status = _.reduce(
        this.imageObjects,
        (result, value, key) => {
          let temVal = null;
          // console.log('test', (value.status === 'selected' && value.correct));
          if ((value.status === 'selected' && value.correct) || (value.status === 'correct' && value.correct)) {
            temVal = result && true;
            // value.block = true;
            // value.status = 'correct';
          } else {
            if (value.status === 'selected') {
              temVal = false;
              // value.block = true;
              // value.status = 'incorrect';
              setTimeout(() => {
                // value.block = false;
                // value.status = 'rest';
              }, 1000);
            } else {
              if (value.status === 'rest' && !value.correct) {
                temVal = result && true;
              }
            }
          }
          return temVal;
        },
        true
      );
      console.log('ANSWER: ', status);
      if (!status) {
        _.each(this.imageObjects, (item, key) => {
          console.log('item', item);
        });
      }
      return status;
    },
  },
  computed: {
    /**
     * computed value to watch if game should be checkd
     * @method checkGame
     * @return {Boolean}  if true then performe check action
     */
    checkGame() {
      return this.$store.getters.checkGame;
    },
    /**
     * computed value to watch if game should be resetGame
     * @method resetGameSwitch
     * @return {Boolean}  if true then performe reset action
     */
    resetGameSwitch() {
      return this.$store.getters.resetGame;
    },
  },
  watch: {
    checkGame: function (newStatus, oldStatus) {
      if (newStatus) {
        this.$store.dispatch('checkGame', this.checkGameAction());
        this.$store.commit('CHECK_GAME', false);
      }
    },
    resetGameSwitch(newStatus, oldStatus) {
      // console.log('newStatus', newStatus);
      if (newStatus) {
        this.resetGameAction();
        this.$store.dispatch('resetGame');
      }
    },
  },
};
</script>
<style lang="scss" scoped>
// $hoverColor: rgb(236, 158, 40);
// $selectColor: rgb(29, 156, 190);
// $correctColor: rgb(52, 180, 107);
// $incorretColor: rgb(228, 8, 21);
.tr-select-image {
  .tr-image {
  }
  .image-rest {
  }
  .image-disabled {
  }
  .image-selected {
    // box-shadow: inset 0 0 20px 3px $selectColor;
  }
  .image-correct {
    // box-shadow: inset 0 0 20px 3px $correctColor;
  }
  .image-wrong {
    // box-shadow: inset 0 0 20px 3px $incorretColor;
  }
}
</style>
